export const SESSION_TIMEOUT_EVENT = 'agd.session-timeout';

import { DEFAULT_POST_AUTH_PATH } from '../rbac/landingPage';
import { WIZARD_FLOW_PATH_PREFIXES } from './wizardCategoryRoute';

const REDIRECT_KEY = 'agd.timeout.redirectTo';

export function storeTimeoutRedirectPath(): void {
  try {
    const v = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    sessionStorage.setItem(REDIRECT_KEY, v);
  } catch {
    // ignore
  }
}

export function readTimeoutRedirectPath(): string | null {
  try {
    return sessionStorage.getItem(REDIRECT_KEY);
  } catch {
    return null;
  }
}

export function clearTimeoutRedirectPath(): void {
  try {
    sessionStorage.removeItem(REDIRECT_KEY);
  } catch {
    // ignore
  }
}

const BLOCKED_RETURN_PATH_PREFIXES = [
  '/session-timeout',
  '/logged-out',
  '/unauthorized',
  // Create-case-request wizard state is permission-sensitive; always land on the app root
  // after re-auth so permission-based landing resolution can pick the correct home page.
  ...WIZARD_FLOW_PATH_PREFIXES,
] as const;

/** Resolve where to send the user after re-authenticating from session timeout. */
export function resolveTimeoutReturnPath(
  stored: string | null | undefined,
  fallback = DEFAULT_POST_AUTH_PATH,
): string {
  const candidate = (stored ?? fallback).trim() || fallback;
  if (BLOCKED_RETURN_PATH_PREFIXES.some((prefix) => candidate.startsWith(prefix))) return fallback;
  return candidate.startsWith('/') ? candidate : `/${candidate}`;
}

export function triggerSessionTimeout(): void {
  try {
    window.dispatchEvent(new Event(SESSION_TIMEOUT_EVENT));
  } catch {
    // ignore
  }
}

